import { render, staticRenderFns } from "./TestLeft.vue?vue&type=template&id=85075cac&scoped=true&"
import script from "./TestLeft.vue?vue&type=script&lang=js&"
export * from "./TestLeft.vue?vue&type=script&lang=js&"
import style0 from "./TestLeft.vue?vue&type=style&index=0&id=85075cac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85075cac",
  null
  
)

export default component.exports